import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

const useManagerTotalizers = () => {
  const query = useQuery({
    queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_TOTALIZERS],
    queryFn: AdminManagementCompaniesService.getTotalizers,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar totalizadores.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useManagerTotalizers;
